export { default, getServerSideProps } from '@/views/B2BCheckout';
